import { Address, UserInfoResponse } from '@shared/types'
import { toUpperCaseAddress } from '@shared/utils'

import { NameAndAddressBase } from './NameAndAddressBase'

export interface NameAndAddressProps {
  user: UserInfoResponse
  isUppercase?: boolean
  /** defaults to string translated from key `common-name-and-address` */
  label?: string
}

export const NameAndAddressFormSection = (props: NameAndAddressProps) => {
  const { user, isUppercase, label } = props

  let address: Address
  let firstNames: string
  let lastName: string

  if (isUppercase) {
    address = toUpperCaseAddress(user.address)
    firstNames = user.firstNames.toUpperCase()
    lastName = user.lastName.toUpperCase()
  } else {
    address = user.address
    firstNames = user.firstNames
    lastName = user.lastName
  }

  return <NameAndAddressBase address={address} firstNames={firstNames} lastName={lastName} label={label} />
}
